import React from "react";
import Img1 from "./img/webp/23Architecture textile modulaire avec toiles tendues et structure métallique – design contemporain et ombrage extérieur.webp";   // remplace par ton image
import Img2 from "./img/webp/US_SHADE.webp";  
import Img3 from "./img/webp/image(2).webp"; // remplace par ton image
// remplace par ton image

import  { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";



const USStretchSection = () => {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <div className="usstretch-section">
      {/* ===== BLOC US STRUCTURE ===== */}
      <div className="usstretch-row">

        

        <div className="usstretch-text">
          <h3 data-aos="fade-up-right">
            <span className="subtitle-us">US</span> STRUCTURE
          </h3><br/>

          <h5 data-aos="fade-up">Structures textiles techniques</h5>

          <p data-aos="fade-up">
            Structures textiles légères et résistantes, conçues pour couvrir
            et protéger les espaces extérieurs tout en offrant une solution
            architecturale moderne et durable.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🏗️ Structure légère et résistante</li>
            <li>☀️ Protection solaire efficace</li>
            <li>🌧️ Résistance aux conditions climatiques</li>
            <li>🎨 Design architectural moderne</li>
            <li>⚡ Installation rapide</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/structure-metallique-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>
        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img1} alt="US Structure architecture textile" />
        </div>
      </div>

      {/* ===== BLOC US SHADE ===== */}
      <div className="usstretch-row">
        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img2} alt="US Shade voile d’ombrage" />
        </div>

        <div className="usstretch-text">
          <h3 data-aos="fade-right">
            <span className="subtitle-us">US</span> SHADE
          </h3><br/>

          <h5 data-aos="fade-up">Voiles d’ombrage</h5>

          <p data-aos="fade-up">
            Solutions de voiles d’ombrage textiles pour créer des zones protégées
            du soleil dans les espaces extérieurs, tout en conservant une
            esthétique légère et contemporaine.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>☀️ Protection efficace contre les UV</li>
            <li>🌬️ Confort thermique en extérieur</li>
            <li>🌧️ Résistance aux intempéries</li>
            <li>🎨 Design moderne et personnalisable</li>
            <li>🏡 Idéal pour terrasses, jardins et espaces publics</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/voile-ombrage-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>

        
      </div>
      {/* ===== BLOC US PARKING ===== */}
<div className="usstretch-row">
  

  <div className="usstretch-text">
    <h3 data-aos="fade-right">
      <span className="subtitle-us">US</span> PARKING
    </h3><br/>

    <h5 data-aos="fade-up">Ombrières & Carports</h5>

    <p data-aos="fade-up">
      Solutions de parkings couverts avec structures métalliques
      et toiles techniques, conçues pour protéger les véhicules
      contre le soleil, la chaleur et les intempéries tout en
      offrant un design moderne et durable.
    </p>

    <h6 data-aos="fade-up">Avantages :</h6>
    <ul data-aos="fade-up">
      <li>🚗 Protection optimale des véhicules</li>
      <li>☀️ Réduction de la chaleur intérieure</li>
      <li>🌧️ Résistance aux intempéries</li>
      <li>🏗️ Structure métallique robuste</li>
      <li>🎨 Design moderne et personnalisable</li>
    </ul>

    <a
      data-aos="fade-up"
      href="/parking-ombrage-abri-voiture-maroc"
      className="learn-more-link"
    >
      En savoir plus <span className="arrow">→</span>
    </a>
    
  </div>
  <div
    className="usstretch-image"
    data-aos="fade-up"
    data-aos-duration="3000"
  >
    <img src={Img3} alt="US Parking ombrière voiture" />
  </div>
</div>
    </div>
  );
};

export default USStretchSection;
